<template>
  <div v-if="loading" class="overlay">
    <div class="spinner" :style="spinnerStyle"></div>
    <slot>{{ $t("products.loading") }}</slot>
  </div>
  <template v-else>

   

    <div v-if="isDelegue && !selectedVeterinarian" class="delegate-warning cart-page container text-align-center  mt-5">
      <div class="container">
        <div class="warning-message">
          <i class="ti ti-alert-circle"></i>
          <span>Veuillez sélectionner un vétérinaire d'abord</span>
          <router-link to="/dashboard" class="warning-link"> Retour au tableau de bord </router-link>
        </div>
      </div>
    </div>

     <template v-else>
        <div class="bg-light" >
      <div class="container">
        <div class="section-header-breadcrumb">
          <h2 class="title-page">
            {{ isTagSearch ? $t("home_client.product_range.categories.food") : $t("products.title") }}
          </h2>
          <label v-if="!isTagSearch">
            <router-link v-if="mainGamme" :to="mainGammeLink" class="gamme-link">
              {{ mainGamme }}
            </router-link>
            <span v-if="mainGamme && subGamme"> > </span>
            <router-link v-if="subGamme" :to="subGammeLink" class="gamme-link">
              {{ subGamme }}
            </router-link>
          </label>
          <label v-else>
            <span>{{ $t("home_client.product_range.categories.food") }}</span>
          </label>
        </div>

        

        <div class="product-list-page">

          <div class="content col-sm-12 col-md-12 col-lg-12 my-4">
            <ProductList ref="productList" :forced-code="isTagSearch ? '' : taxonCode" :products="products" />
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white">
      <div class="service-list container">
        <div class="content col-sm-12 col-md-12 col-lg-12">
          <Service />
        </div>
      </div>
    </div>

    <div class="bg-light-1">
      <div class="question-list container">
        <div class="content col-sm-12 col-md-12 col-lg-12">
          <Question />
        </div>
      </div>
    </div>
    </template>
  
  </template>
</template>

<script>
import ProductList from "@/components/products/ProductList.vue";
import Service from "@/components/Service.vue";
import Question from "@/components/Question.vue";
import { useProductsStore } from "@/stores/productsStore";
import { useGammesStore } from "@/stores/gammesStore";
import { useDelegueStore } from '@/stores/delegueStore';
import { useRegisterStore } from '@/stores/register';

export default {
  name: "taxonList",
  components: {
    ProductList,
    Service,
    Question,
  },
  data() {
    return {
      productsStore: null,
      gammesStore: null,
      currentPage: 1,
      itemsPerPage: 12,
      size: "50px",
      color: "#3498db",
      registerStore: null,
    };
  },
  computed: {
    spinnerStyle() {
      return {
        width: this.size,
        height: this.size,
        borderColor: `${this.color} transparent transparent transparent`,
      };
    },
    isTagSearch() {
      return !!this.$route.query.tag;
    },
    products() {
      return this.productsStore.products;
    },
    loading() {
      return this.productsStore.loading;
    },
    error() {
      return this.productsStore.error;
    },
    gammes() {
      return this.gammesStore ? this.gammesStore.gammes : [];
    },
    taxonId() {
      const slug = this.$route.params.slug;
      return slug ? slug.split("-")[0] : "";
    },
    taxonCode() {
      if (!this.taxonId || !this.gammes || !Array.isArray(this.gammes) || this.gammes.length === 0) {
        return "";
      }

      for (const gamme of this.gammes) {
        if (!gamme) continue;

        // Check if this is the main gamme
        if (gamme.id && gamme.id.toString() === this.taxonId) {
          return gamme.code || "";
        }

        // Check children
        const children = Array.isArray(gamme.childrenDetails) ? gamme.childrenDetails : [];
        for (const child of children) {
          if (child && child.id && child.id.toString() === this.taxonId) {
            return child.code || "";
          }
        }
      }
      return "";
    },
    mainGamme() {
      if (!this.taxonId || !this.gammes || !Array.isArray(this.gammes) || this.gammes.length === 0) {
        return "";
      }

      for (const gamme of this.gammes) {
        if (!gamme) continue;

        // Check if this is the main gamme
        if (gamme.id && gamme.id.toString() === this.taxonId) {
          return gamme.name || "";
        }

        // Check if any child matches (using safer approach)
        const children = Array.isArray(gamme.childrenDetails) ? gamme.childrenDetails : [];
        for (const child of children) {
          if (child && child.id && child.id.toString() === this.taxonId) {
            return gamme.name || "";
          }
        }
      }
      return "";
    },
    subGamme() {
      if (!this.taxonId || !this.gammes || !Array.isArray(this.gammes) || this.gammes.length === 0) {
        return "";
      }

      for (const gamme of this.gammes) {
        if (!gamme) continue;

        const children = Array.isArray(gamme.childrenDetails) ? gamme.childrenDetails : [];
        for (const child of children) {
          if (child && child.id && child.id.toString() === this.taxonId) {
            return child.name || "";
          }
        }
      }
      return "";
    },
    slug() {
      return this.$route.params.slug || "";
    },

    mainGammeLink() {
      if (!this.taxonId || !this.gammes || !Array.isArray(this.gammes) || this.gammes.length === 0) {
        return "";
      }
      for (const gamme of this.gammes) {
        if (!gamme) continue;
        // Check if this is the main gamme
        if (gamme.id && gamme.id.toString() === this.taxonId) {
          return `/dashboard/taxon/${gamme.id}-${gamme.slug}`;
        }
        // Check if any child matches
        const children = Array.isArray(gamme.childrenDetails) ? gamme.childrenDetails : [];
        for (const child of children) {
          if (child && child.id && child.id.toString() === this.taxonId) {
            return `/dashboard/taxon/${gamme.id}-${gamme.slug}`;
          }
        }
      }
      return "";
    },

    subGammeLink() {
      if (!this.taxonId || !this.gammes || !Array.isArray(this.gammes) || this.gammes.length === 0) {
        return "";
      }
      for (const gamme of this.gammes) {
        if (!gamme) continue;
        const children = Array.isArray(gamme.childrenDetails) ? gamme.childrenDetails : [];
        for (const child of children) {
          if (child && child.id && child.id.toString() === this.taxonId) {
            return `/dashboard/taxon/${child.id}-${child.slug}`;
          }
        }
      }
      return "";
    },

    isDelegue() {
        return this.registerStore.user?.role === "delegues";
      },
      selectedVeterinarian() {
        const delegueStore = useDelegueStore();
        return delegueStore.getSelectedVeterinarian;
      },
  },
  created() {
     this.registerStore = useRegisterStore();
    this.productsStore = useProductsStore();
    this.gammesStore = useGammesStore();
    this.gammesStore.fetchGammes();
    this.loadProducts();
  },
  methods: {
    async loadProducts(page = 1) {
      this.productsStore.loading = true;
      this.currentPage = page;
      try {
        if (this.isTagSearch) {
          const tag = this.$route.query.tag;
          await this.productsStore.fetchProductsByTag(tag, { page, itemsPerPage: this.itemsPerPage });
        } else {
          await this.productsStore.fetchProductsByTaxon(this.taxonCode, { page, itemsPerPage: this.itemsPerPage });
        }
      } catch (e) {
        console.error("Error loading products:", e);
      }
      this.productsStore.loading = false;
    },
  },
  watch: {
    "$route.params.slug"() {
      this.currentPage = 1;
      this.loadProducts();
    },
    "$route.query.tag"() {
      this.currentPage = 1;
      this.loadProducts();
    },
  },
};
</script>

<style scoped>
.product-list-page {
  padding: 20px 0;
  text-align: center;
  max-width: 100%;

  .content {
    position: relative;
  }
}

.product-list-recommanded {
  padding: 30px;
  text-align: center;
  max-width: 100%;
}

.service-list {
  padding: 30px;
  text-align: center;
  max-width: 100%;
}

.question-list {
  padding: 40px;
  text-align: center;
  max-width: 100%;
}

.section-header-breadcrumb {
  text-align: left;
  font-style: normal;
  position: relative;

  .title-page {
    font-size: 30px;
    font-weight: bold;
    color: #1e347d;
  }

  label {
    font-size: 15px;
    font-weight: normal;

    span {
      color: #1e347d;
    }
  }
}

@media (max-width: 768px) {
  .product-list-page {
    padding: 15px;
  }

  .product-list-recommanded {
    padding-left: 120px;
    padding-right: 120px;
  }
}

.error,
.empty {
  color: #777;
  font-size: 1.2em;
}

.error {
  color: red;
  font-weight: bold;
}

.empty {
  color: #888;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 1.2rem;
}

.spinner {
  border: 4px solid;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.section-header-breadcrumb {
  text-align: left;
  font-style: normal;
  position: relative;

  .title-page {
    font-size: 30px;
    font-weight: bold;
    color: #1e347d;
  }

  label {
    font-size: 15px;
    font-weight: normal;

    span {
      color: #1e347d;
    }
  }

  .gamme-link {
    color: #1e347d;
    text-decoration: none;
    cursor: pointer;
  }

  .gamme-link:hover {
    text-decoration: underline;
  }
}

.delegate-warning{
    margin-top: 5rem !important;
    text-align: center;
  }
</style>
